<p>CoreConfig works!</p>
